<template>
    <div class="pc-basket-sidebar-section">
        <div class="pc-basket-sidebar-main-heading" v-if="!confirmationPage">
            <h5 class="primary-heading">{{$resourceString['myBasket.Label.TotalBasketItems']}}</h5>
        </div>
        <div class="pc-basket-sidebar-details-btn">
            <div class="pc-basket-sidebar-details" v-if="individualSamples || projectSamples || designTraySample || confirmationPage">
                <div class="pc-basket-sidebar-list" v-if="individualSamples">
                    <h5 class="primary-heading">{{ $resourceString['myBasket.Sidebar.Label.Samples'] }}: <span>{{ individualSamplesCount }}</span></h5>
                </div>
                <div class="pc-basket-sidebar-list" v-if="projectSamples">
                    <h5 class="primary-heading">{{ $resourceString['myBasket.Sidebar.Label.ProjectSamples'] }}: <span>{{ projectSamplesCount }}</span></h5>
                </div>
                <div class="pc-basket-sidebar-list" v-if="designTraySample">
                    <h5 class="primary-heading">{{$resourceString['myBasket.Sidebar.Label.DesignTrays']}}: <span>{{ designTraySampleCount }}</span></h5>
                </div>
                <div class="pc-basket-sidebar-list" v-if="confirmationPage">
                    <h5 class="primary-heading">{{$resourceString['myBasket.Sidebar.Label.NeedToOrderYourOtherSamples']}}</h5>
                </div>
            </div>
            <div class="pc-basket-sidebar-btn">
                <button type="button" class="btn btn-white back-btn border-dark" v-if="!!backLabel" @click="backAction">
                    <span class="png-icon png-icon-icons-glyph--k-arrow-back"> </span>
                    <span class="btn-label">{{ backLabel }}</span>
                </button>
                <button :disabled="isNextDisabled" type="button" class="btn btn-primary next-btn" v-if="!!nextLabel" @click="nextAction">
                    <span class="btn-label">{{nextLabel}}</span>
                    <span class="png-icon png-icon-icons-glyph--ko-arrow-next"></span>
                </button>

                <button type="button" class="btn btn-white back-btn border-dark next-btn explore-btn-1" v-if="!!exploreButtonOneLabel" @click="exploreButtonOneAction">
                    <span class="btn-label">{{exploreButtonOneLabel}}</span>
                    <span class="png-icon png-icon-icons-glyph--k-arrow-next"></span>
                </button>
                <button type="button" class="btn btn-white back-btn border-dark next-btn explore-btn-2" v-if="!!exploreButtonTwoLabel" @click="exploreButtonTwoAction">
                    <span class="btn-label">{{exploreButtonTwoLabel}}</span>
                    <span class="png-icon png-icon-icons-glyph--k-arrow-next"></span>
                </button> 
                <!-- Validation Error Message -->
                <div class="field-validation-error text-secondary mt-2" v-if="isError && errorMsg" v-html="errorMsg" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["individualSamples", "projectSamples", "designTraySample", "backLabel", "backAction", "nextLabel", "nextAction", "individualSamplesCount", "projectSamplesCount", "designTraySampleCount", "confirmationPage", "exploreButtonOneLabel", "exploreButtonOneAction", "exploreButtonTwoLabel", "exploreButtonTwoAction", "isNextDisabled", "errorMsg", "isError"],
    methods: {}
}
</script>